import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M14.8223 8.84264C14.0372 9.61422 13.0897 10 11.9797 10C10.8697 10 9.92894 9.61422 9.15736 8.84264C8.38578 8.07106 8 7.13029 8 6.0203C8 4.91032 8.38578 3.96278 9.15736 3.17766C9.92894 2.39255 10.8697 2 11.9797 2C13.0897 2 14.0372 2.39255 14.8223 3.17766C15.6074 3.96278 16 4.91032 16 6.0203C16 7.13029 15.6074 8.07106 14.8223 8.84264ZM18.3608 19.5243C18.7989 19.2252 19.0044 18.699 18.9863 18.1689C18.8025 12.8138 16.7616 11 12 11C7.23836 11 5.1975 12.8138 5.01373 18.1689C4.99554 18.699 5.20105 19.2252 5.63913 19.5243C6.80768 20.322 8.81669 21 12 21C15.1833 21 17.1923 20.322 18.3608 19.5243Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Account);
